import { z } from 'zod'

export const PiloteOrganizationTypeZod = z.enum(['ORGANIZATION', 'INSTITUTION', 'LOCAL_HOST', 'OTHER', 'ENTERPRISE'])
export type PiloteOrganizationType = z.infer<typeof PiloteOrganizationTypeZod>

export const PiloteOrganizationRecordZod = z.object({
  id: z.number(),
  uuid: z.string(),
  central_id: z.number(),
  active: z.boolean(),
  name: z.string(),
  type: PiloteOrganizationTypeZod,
  version: z.number(),
})
export type PiloteOrganizationRecord = z.infer<typeof PiloteOrganizationRecordZod>
